<template src="./list.html"></template>

<script>
import TopService from 'Services/TopService';
import Pagination from 'Components/pagination/Pagination.vue';

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      topsJP: [],
      topsVN: [],
      i18n: 2,
    };
  },

  created() {
    this.list();
  },

  methods: {
    convertHTML(value) {
      if (value) {
        if (value.length < 800) {
          return `${value.replace(/(<([^>]+)>)/g, '')}`;
        }
        return `${value.replace(/(<([^>]+)>)/g, '').substring(0, 800)}...`;
      }

      return '';
    },
    list() {
      this.isLoading = true;
      if (localStorage.getItem('lang') === 'ja') {
        this.i18n = 1;
      }

      const paramsJP = {
        type: 3,
        national: 1,
        i18n: this.i18n,
      };

      const paramsVN = {
        type: 3,
        national: 2,
        i18n: this.i18n,
      };

      TopService.listIntern(paramsJP)
        .then((response) => {
          this.topsJP = response.data;
        })
        .catch(() => {});
      TopService.listIntern(paramsVN)
        .then((response) => {
          this.topsVN = response.data;
        })
        .catch(() => {});
    },
  },
};
</script>
